import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

// Shared marketing-page footer, extracted from the decluttered landing footer
// (2026-08-24 design-system pass). One footer for every public page.

export default function SiteFooter() {
  const go = useNavigate()
  return (
    <footer className="bg-white border-t border-gray-100 py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <img src="/assets/bragbox-hero.png" alt="BragBox" className="h-10" />
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Button variant="ghost" size="sm" onClick={() => go('/contact')}>Contact</Button>
            <Button variant="ghost" size="sm" onClick={() => go('/privacy')}>Privacy</Button>
            <Button variant="ghost" size="sm" onClick={() => go('/terms')}>Terms</Button>
          </div>
          <p className="text-gray-400 text-sm">© 2026 BragBox</p>
        </div>
      </div>
    </footer>
  )
}
